<template>
  <dl class="metadata-list">
    <dt class="a11y-hidden">메타 정보</dt>

    <template v-if="isMovie">
      <dd v-if="year" class="dot-item">
        <em class="a11y-hidden">개봉연도: </em>{{ year }}
      </dd>
      <dd v-if="playTime" class="dot-item">
        <em class="a11y-hidden">상영시간: </em>{{ playTime }}
      </dd>
    </template>

    <template v-else>
      <dd v-if="hasSeason" class="dot-item">
        <em class="a11y-hidden">에피소드: </em
        >{{ `시즌 ${Number(seasonList) || '1'}개` }}
      </dd>
    </template>

    <dd v-if="targetAge" class="dot-item">
      <em class="a11y-hidden">시청연령: </em
      ><AgeGrade :target-age="targetAge" :section="kmrbCode" :size="24" />
    </dd>
    <dd v-if="genreText" class="dot-item">
      <em class="a11y-hidden">종류: </em>{{ genreText }}
    </dd>
    <dt class="a11y-hidden">태그 정보</dt>
    <dd v-if="isCC" class="tag-item">
      <img
        :src="require('@/assets/images/common/element-icons-tag-cc.svg')"
        width="34"
        height="24"
        alt="자막"
      />
    </dd>
  </dl>
</template>
<script setup>
  import { computed, defineProps } from 'vue'
  import AgeGrade from '@/components/player/AgeGrade.vue'

  const props = defineProps({
    contentInfo: {
      type: Object,
      default: null,
    },
    contentType: {
      type: String,
      default: '',
    },
  })

  const isMovie = computed(() => props.contentType === 'movie')

  const movieGenre = computed(
    () => props.contentInfo?.genre?.list[0]?.text || '',
  )
  const vodGenre = computed(() => props.contentInfo?.genretext || '')

  const genreText = computed(() =>
    isMovie.value ? movieGenre.value : vodGenre.value,
  )
  const isCC = computed(
    () => props.contentInfo?.isCC?.toLowerCase() === 'y' || false,
  )
  const kmrbCode = computed(() => {
    const { kmrbcode = '' } = props.contentInfo
    return kmrbcode ? 'movie' : 'vod'
  })
  const playTime = computed(() => {
    const _playTime = props.contentInfo?.playtime || ''
    return `${Math.floor(Number(_playTime) / 60)}분`
  })
  const seasonList = computed(
    () => props.contentInfo?.season_list?.count || '0',
  )
  const targetAge = computed(
    () =>
      props.contentInfo?.seasontargetage || props.contentInfo?.targetage || '',
  )
  const year = computed(() => props.contentInfo?.originalreleaseyear || '')

  const hasSeason = computed(() => Number(seasonList.value) >= 1)
</script>
